import { __ } from 'i18n';

export const STATUSES = {
   'dnd': __('Не турбувати'),
   'online': __('У мережі'),
   'offline': __('Не в мережі'),
   'unavailable': __('Недоступний'),
   'xa': __('Відсутній тривалий час'),
   'away': __('Відійшов')
};
